import { configureStore } from '@reduxjs/toolkit'
import loginReducers from '../reducers/loginReducers'

export const store = configureStore({
  reducer: {
    login: loginReducers,
  }
})